export function stripHTML(htmlString: string = ""): string {
  if (!htmlString) return "";

  const clean = htmlString;

  return clean.replace(/<\/?[^>]+(>|$)/g, "");
}

export function stripHTMLKeepBreak(htmlString: string = ""): string {
  if (!htmlString) return "";

  let clean = htmlString;

  clean = clean.replace(/<br\s*\/?>/gi, "\n");
  clean = clean.replace(/<\/?[^>]+(>|$)/g, "");

  return clean.trim();
}

export function stripHTMLKeepBreakWithFont(
  htmlString: string = "",
  font: string = "Montserrat",
): string {
  if (!htmlString) return "";

  let clean = htmlString;

  clean = clean.replace(/<br\s*\/?>/gi, "<br/>");
  clean = clean.replace(/<\/?[^>]+(>|$)/g, "");

  return `<div style="font-family: '${font}', sans-serif; white-space: pre-line;">${clean}</div>`;
}

export function sanitizeHTMLKeepStyleWithFont(
  htmlString: string = "",
  font: string = "Montserrat",
): string {
  if (!htmlString) return "";

  let clean = htmlString;

  clean = clean.replace(/font-family:[^;"]+;?/gi, "");
  clean = clean.replace(/font-size:[^;"]+;?/gi, "");
  clean = clean.replace(
    /style="([^"]*)"/gi,
    (styleContent: any) =>
      `style="font-family: '${font}', sans-serif; ${styleContent}"`,
  );

  clean = clean.replace(
    /<(p|span|div|h1|h2|h3|h4|h5|li|td|th)(?![^>]*style=)/gi,
    `<$1 style="font-family: '${font}', sans-serif;"`,
  );

  return clean;
}

export interface ParsedProductHTML {
  links: any[] | null;
  descriptionHTML: string;
}

export function parseStructuredListFromHTML(
  rawHTML = "",
  {
    itemDelimiter = "***",
    fieldDelimiter = "::",
    fields = [],
    strip = stripHTML,
  }: {
    itemDelimiter?: string;
    fieldDelimiter?: string;
    fields?: string[];
    strip?: (htmlString?: string) => string;
  } = {},
) {
  if (!rawHTML) return [];

  const clean = strip(rawHTML);

  return clean
    .split(itemDelimiter)
    .map((item) => item.trim())
    .filter(Boolean)
    .map((item) => {
      const parts = item.split(fieldDelimiter).map((p) => p.trim());

      // If schema provided → map to object
      if (fields.length) {
        const obj: Record<string, string | null> = {};

        fields.forEach((key, index) => {
          obj[key] = parts[index] !== undefined ? parts[index] : null;
        });

        return obj;
      }

      // Fallback → return raw array
      return parts;
    });
}
